import { Error } from '../machines/addOnsConfiguration/types';
import { TFunction } from 'react-i18next';

export const getErrorDescription = (
  error: Error,
  t: TFunction<'subscriptions-manager'[]>
) => {
  if (error.errorCode === 'NothingAllocated') {
    return t('components_allocations.nothing_was_allocated');
  }
  if (error.errorCode === 'InvalidAllocation') {
    return t('components_allocations.invalid_components_allocation');
  }
  if (!error.errorCode) {
    return t(
      'components_allocations.we_were_unable_to_display_your_components'
    );
  }
};
